export default "<video\n    #videopreload\n    preload=\"auto\"\n    webkit-playsinline\n    playsinline\n    [src]=\"src\"\n></video>\n";